<template>
  <div class="popup">
    <van-popup
      v-model="popupVisible"
      :closeOnClickOverlay="closeOnClickOverlay"
      closeable
      @close="close"
      position="center"
      round
      :style="{ height: height + 'px', width: width, paddingTop: '36px' }"
    >
    <div class="content">
      <van-sticky>
        <p class="title">{{ title }}</p>
      </van-sticky>
      <div class="txt" :style="{height: (height - 90) + 'px'}">
        <div v-html="content"></div>
      </div>
    </div>
    </van-popup>
  </div>
</template>
<script>
// import http from '../../cmmon/js/http.js'
export default {
  name: 'popupTemp',
  props: {
    popupVisible: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: '300'
    },
    width: {
      type: String,
      default: '290px'
    },
    title: {
      type: String,
      default: '操作指引'
    },
    content: {
      type: String,
      default: ''
    },
    closeOnClickOverlay:Boolean
  },
  data() {
    return {
      
    }
  },
  mounted() {
    
  },
  methods: {
    close() {
      this.$emit('closePopup')
    }
  }
}
</script>


<style lang="less" scoped>
.content {
  padding-bottom: 20px;
  .title {
    font-size: 16px;
    font-weight: bold;
    text-align: center;
  }
  .txt {
    padding: 0 15px 20px;
    overflow: scroll;
    margin-top: 12px;
  }
}
</style>